import { requestGlobalSettingData, requestMain } from "../../apis";
import localStorageKey from "../../enumerations/localStorageKey";

const currency =
  window.localStorage.getItem(localStorageKey.DEFAULT_CURRENCY) ||
  process.env.REACT_APP_DEFAULT_CURRENCY;

export const apiGetCustomerService = (params) =>
  requestMain("get", `/${currency}/customerservice`, params, false, false);

export const apiGetCustomerServiceNoCurrency = (params) =>
  requestGlobalSettingData("get", `/customerservice`, params, true, true);
